import { RDate } from "../../core";
import { POrderSummaryCancelled } from "./POrderSummaryCancelled";
import { POrderSummaryCompleted } from "./POrderSummaryCompleted";
export function fromResponseState(params) {
    var _a, _b;
    const { state, orderInfo } = params.orderSummaryResponse;
    const { createdAt, requestedFulfillmentTime, timezone } = orderInfo;
    const restaurantAddress = {
        name: params.orderSummaryResponse.restaurantName,
        street: params.orderSummaryResponse.restaurantAddressStreet,
        postCode: params.orderSummaryResponse.restaurantAddressPostCode,
        city: params.orderSummaryResponse.restaurantAddressCity,
    };
    const fulfillmentMethodType = orderInfo.fulfillmentMethodType === "Takeaway"
        ? {
            type: "Takeaway",
            restaurantAddress,
        }
        : {
            type: orderInfo.fulfillmentMethodType,
        };
    const isPreorder = getIsPreorder(createdAt, requestedFulfillmentTime, timezone);
    switch (state.tag) {
        case "Placed":
            return { type: "Loading", isFinal: false };
        case "WaitingForPayment":
            return {
                type: "WaitingForPayment",
                isBlik: orderInfo.isBlikLevel0,
                isFinal: false,
            };
        case "WaitingForDispatch":
            return {
                type: "WaitingForDispatch",
                openAt: state.openAt,
                nextAvailableDay: state.nextAvailableDay !== null
                    ? RDate.fromUtcTimeString(state.nextAvailableDay, timezone)
                    : null,
                isPreorder,
                isFinal: false,
            };
        case "WaitingForConfirmation": {
            const date = requestedFulfillmentTime !== null
                ? RDate.fromUtcTimeString(requestedFulfillmentTime, timezone)
                : null;
            return {
                type: "WaitingForConfirmation",
                fulfillmentMethodType,
                isPreorder,
                fulfillmentTime: date
                    ? {
                        date: date.formatDDMMYYYY(),
                        hour: date.formatHHmm(),
                    }
                    : null,
                isFinal: false,
            };
        }
        case "Completed":
            return new POrderSummaryCompleted({
                restaurantAddress,
                completedAt: RDate.fromUtcTimeString(state.contents[1], state.contents[0]),
                isPreorder,
                fulfillmentMethodType,
                restaurantPhones: params.orderSummaryResponse.restaurantPhones,
                now: () => RDate.now(state.contents[0]),
                displayStatus: (_a = params.orderSummaryResponse.displayStatus) !== null && _a !== void 0 ? _a : null,
            });
        case "Cancelled": {
            const isPaymentFailure = ((_b = state.confirmationSource) === null || _b === void 0 ? void 0 : _b.tag) === "System" &&
                (state.confirmationSource.status === "PaymentDeclined" ||
                    state.confirmationSource.status === "PaymentTimeout");
            return new POrderSummaryCancelled({
                reason: state.reason,
                confirmationSource: state.confirmationSource,
                isOnlinePayment: orderInfo.onlinePayment,
                restaurantPhones: params.orderSummaryResponse.restaurantPhones,
                retryOrder: params.retryOrder,
                performPaymentRetry: isPaymentFailure
                    ? params.performPaymentRetry
                    : null,
                onPaymentRetrySuccess: isPaymentFailure
                    ? params.onPaymentRetrySuccess
                    : null,
            });
        }
    }
}
function getIsPreorder(createdAt, requestedFulfillmentTime, timezone) {
    if (requestedFulfillmentTime === null) {
        return false;
    }
    const orderingDate = RDate.fromUtcTimeString(createdAt, timezone);
    const fulfullmentDate = RDate.fromUtcTimeString(requestedFulfillmentTime, timezone);
    return !orderingDate.isSameDate(fulfullmentDate);
}
